import {
  Box,
  Card,
  CardContent,
  Divider,
  IconButton
} from "@mui/material";
import { Pen } from "lucide-react";
import ClampedText from "../../../components/common/ClampedText";
import OptionDisplay from "../../../components/common/OptionDisplay";

const CurrentPositionCard = ({ data, onEdit, dropDownOptions }) => {
  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: 3,
        mb: 2,
        boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          borderColor: "primary.main",
        },
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          p: 2,
        }}
      >
        <Box sx={{ flex: 1 }}>
          {/* Job Title */}
          <ClampedText
            variant="h6"
            sx={{
              fontWeight: 600,
              mb: 0.5,
              color: "text.primary",
            }}
          >
            Current Position: {data.current_job_title || "No Job Title"}
          </ClampedText>

          {/* Years of experience */}
          <ClampedText variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            {data.years_of_experience
              ? `${data.years_of_experience} years of experience`
              : "No experience added"}
          </ClampedText>

          {/* Divider */}
          <Divider sx={{ my: 1 }} />

          {/* Aviation specialization */}
          <ClampedText
            variant="body2"
            sx={{ color: "primary.main", fontWeight: 500, mb: 0.5 }}
          >
            {data.aviation_specialization || "No specialization selected"}
          </ClampedText>

          {/* Aircraft type */}
          <ClampedText variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
            <strong>Aircraft Type:</strong>{" "}
            {/* {data.aircraft_type || "Not specified"} */}
            <OptionDisplay
              options={dropDownOptions.aircraftTypeChoices}
              value={data.aircraft_type}
              multi
            />
          </ClampedText>

          {/* Hours */}
          <ClampedText variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
            <strong>Total Hours:</strong> {data.total_hours ?? "Not provided"}
          </ClampedText>
          <ClampedText variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
            <strong>Pilot-in-Command Hours:</strong>{" "}
            {data.pilot_in_command_hours ?? "Not provided"}
          </ClampedText>
          <ClampedText variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
            <strong>First Officer Hours:</strong>{" "}
            {data.first_officer_hours ?? "Not provided"}
          </ClampedText>

          {/* Last flight date */}
          <ClampedText variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
            <strong>Last Flight Date:</strong>{" "}
            {data.last_flight_date || "Not recorded"}
          </ClampedText>

          {/* Additional details */}
          {data.additional_details && (
            <ClampedText
              variant="body2"
              color="text.secondary"
              sx={{
                mt: 1,
                fontStyle: "italic",
                lineHeight: 1.5,
                whiteSpace: "pre-line",
              }}
            >
              {data.additional_details}
            </ClampedText>
          )}
        </Box>

        {/* Edit Button */}
        <IconButton
          onClick={onEdit}
          sx={{
            bgcolor: "primary.50",
            "&:hover": { bgcolor: "primary.100" },
            borderRadius: 2,
            ml: 2,
          }}
        >
          <Pen size={18} />
        </IconButton>
      </CardContent>
    </Card>
  );
};

export default CurrentPositionCard;
